import type { Product } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import {
  SHORTCUT_CATALOG_PRODUCT_FIELDS,
  SHORTCUT_LABELS_FIELDS,
  PRODUCT_REVIEW_FIELDS
} from '@@partner:graphql/shortcuts'

export interface FetchProductDetails {
  productDetails: Product
}

export interface FetchProductDetailsVariables {
  productId?: GQL_ID
}

export const GQL_QUERY_FETCH_PRODUCT_DETAILS = gql`
  query($productId: ID!) {
    productDetails(id: $productId) {
      ${SHORTCUT_CATALOG_PRODUCT_FIELDS}
      productProperties {
        fats
        proteins
        calories
        carbohydrate
      }
      
      eans {
        id
        ean
      }
      categoryIds
      categoryChains {
        id
        namesChain
        pathsChain
      }
      marketingLabels {
        ${SHORTCUT_LABELS_FIELDS}
      }
      images {
        id
        url
      }
      imagesIds {
        id
        weight
      }

      prices {
        id
        shop_id
        currentPrice
        olderPrice
        salePeriod {
          start
          finish
        }
        min
        max
        step
        quant
        quantAmount
        isDefault
        shop {
          id
          name
        }
      }

      attributes {
        id
        attribute {
          id
          created_at
          updated_at
          name
          slug
          is_system
          prefix
          postfix
          is_searchable
          xname
          is_filterable
          filter_name
          value_type
        }
        value
      }

      i18n {
        name
        short_description
        pkg
        ingredients
        nutval
        manufacturer
        country
        volume
        language_code
        storage_conditions
      }
    }
  }
`

export const useFetchProductDetails = (productId?: GQL_ID) => {
  return useQuery<FetchProductDetails, FetchProductDetailsVariables>(
    GQL_QUERY_FETCH_PRODUCT_DETAILS,
    {
      variables: {
        productId
      },
      skip: !productId,
      fetchPolicy: 'cache-and-network'
    }
  )
}
